export const toTitleCase = (str: string):string => {
    /**
     * https://stackoverflow.com/questions/196972/convert-string-to-title-case-with-javascript
     *
     * Returns a NEW string (does not alter existing string)
     */
    return str?.replace(
        /\w\S*/g,
        (txt: string) => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
};